let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8swF7")).then(() => parcelRequire('kf6KA'));